import * as types from '../mutation-types'
import { API } from '../../api';
import { WEIXIN_PAY } from '../../weixin'
import { CONFIG } from '../../config';

export default {
    namespaced: true,
    state: {
        showWebWechatPayCode: false,
        webWechatPayCodeValue: '',
        webWechatPayPrice: 0
    },
    mutations: {},
    actions: {
        // 下单
        createPayOrder({ state }, params) {
            API.createOrder(params.params, function(data) {
                console.log('下单成功结果-----', data)

                switch(CONFIG.platform) {
                    case 'wechat':
                        // 调起微信支付
                        WEIXIN_PAY.createOrder(data.return, function(data) {
                            console.log('clickPay-----支付成功', data)
                            if(params.sucCb && typeof(params.sucCb) == 'function') {
                                params.sucCb();
                            }
                        }, function(data) {
                            console.error('clickPay-----支付失败', data)
                            if(params.failCb && typeof(params.failCb) == 'function') {
                                params.failCb();
                            }
                        })
                        break;
                    case 'web':
                        state.webWechatPayCodeValue = data.return;
                        state.webWechatPayPrice = parseFloat(data.product.price / 100);
                        setTimeout(() => {
                            state.showWebWechatPayCode = true;
                        }, 20);
                        break;
                    default:
                        if(params.failCb && typeof(params.failCb) == 'function') {
                            params.failCb();
                        }
                        break;
                }
            })
        }
    }
}